module.exports = __webpack_public_path__ + "img/full-banner.86b813a4.jpg";